// src/components/ProductsPanel.jsx
// ProductsPanel (ULTRA PRO + Cpuntos como PERMISO) + ✅ MISMO DISEÑO "HOME" (fondo tipo hero)
// ✅ Mantiene toda tu lógica y FIX CRITICO (_docId real)
// ✅ Estética: glass + gradient + hero background (sin afectar el resto del sitio)
// ✅ Corrige error que tenías: NO puede haber un <button> suelto fuera del return

import React, { useEffect, useMemo, useRef, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
  doc,
  runTransaction,
  serverTimestamp,
  orderBy,
} from "firebase/firestore";
import Logros from "./logros";

let COLORS_SAFE = {};
try {
  // eslint-disable-next-line global-require
  COLORS_SAFE = require("../constants/ui").COLORS || {};
} catch {
  COLORS_SAFE = {};
}

const PUNTOS_MIN_PERMISO = 10;

// ===== Helpers =====
const currency = (v) =>
  new Intl.NumberFormat("es-DO", {
    style: "currency",
    currency: "DOP",
    maximumFractionDigits: 2,
  }).format(Number(v || 0));

const pad2 = (n) => String(n).padStart(2, "0");
const dayKeyFromDate = (d = new Date()) =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

const normalizeNumber = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const getImage = (obj) => {
  if (!obj) return "";
  if (typeof obj.imageUrl === "string" && obj.imageUrl.trim()) return obj.imageUrl.trim();
  if (Array.isArray(obj.images) && obj.images.length > 0 && typeof obj.images[0] === "string")
    return obj.images[0].trim();
  return "";
};

/** ✅ MISMO DISEÑO "HOME": hero background + glass */
const GlobalProductsHomeCSS = () => (
  <style>{`
    :root{
      --bg: #f6f9ff;
      --bg2: #eef6ff;
      --surface: rgba(255,255,255,.78);
      --surface2: rgba(255,255,255,.62);
      --border: rgba(30,64,175,.14);
      --text: #0f172a;
      --muted: rgba(15,23,42,.72);
      --accent: #06b6d4;
      --accent2: #2563eb;
      --ring: rgba(6,182,212,.35);
      --shadow: 0 16px 40px rgba(2,6,23,.08);
      --shadow2: 0 12px 30px rgba(2,6,23,.10);
    }

    .hp-hero{
      position: relative;
      border-radius: 22px;
      overflow: hidden;
    }

    /* fondo tipo "Home" */
    .hp-hero::before{
      content:"";
      position:absolute;
      inset:-2px;
      background:
        radial-gradient(900px 600px at 12% 10%, rgba(37,99,235,.16), transparent 55%),
        radial-gradient(900px 600px at 88% 12%, rgba(6,182,212,.18), transparent 50%),
        radial-gradient(900px 600px at 30% 90%, rgba(99,102,241,.12), transparent 55%),
        linear-gradient(180deg, var(--bg), var(--bg2));
      z-index: 0;
      filter: saturate(1.03);
    }

    .hp-hero::after{
      content:"";
      position:absolute;
      inset:0;
      background: linear-gradient(180deg, rgba(255,255,255,.25), rgba(255,255,255,.05));
      z-index: 0;
      pointer-events:none;
    }

    .hp-inner{
      position: relative;
      z-index: 1;
      background: linear-gradient(180deg, rgba(255,255,255,.30), rgba(255,255,255,.12));
      border: 1px solid rgba(30,64,175,.16);
      box-shadow: var(--shadow);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border-radius: 22px;
      padding: 14px;
      display: grid;
      gap: 14px;
    }

    .hp-title{
      font-size: 22px;
      font-weight: 950;
      margin: 0;
      background: linear-gradient(90deg, var(--accent2), var(--accent));
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      letter-spacing: .2px;
    }

    .hp-help{ color: var(--muted); font-size: 14px; line-height: 1.6; }

    .hp-tabs .tab{
      appearance:none;
      border: 1px solid rgba(37,99,235,.18);
      background: rgba(255,255,255,.75);
      color: rgba(15,23,42,.85);
      padding: 10px 12px;
      border-radius: 999px;
      font-weight: 900;
      cursor:pointer;
      box-shadow: 0 10px 25px rgba(2,6,23,.08);
      transition: transform .12s ease, box-shadow .12s ease, border-color .12s ease;
      white-space: nowrap;
    }
    .hp-tabs .tab:hover{ transform: translateY(-1px); box-shadow: 0 12px 28px rgba(2,6,23,.10); }
    .hp-tabs .tab.active{
      border-color: rgba(6,182,212,.45);
      box-shadow: 0 0 0 4px var(--ring), 0 12px 28px rgba(2,6,23,.10);
      background: linear-gradient(90deg, rgba(37,99,235,.14), rgba(6,182,212,.14));
    }

    .hp-badge{
      display:inline-flex;
      align-items:center;
      gap:8px;
      font-weight: 950;
      padding: 8px 12px;
      border-radius: 999px;
      border: 1px solid rgba(37,99,235,.14);
      background: rgba(255,255,255,.70);
      box-shadow: 0 10px 25px rgba(2,6,23,.06);
      color: rgba(15,23,42,.92);
      white-space: nowrap;
    }

    .hp-input{
      width:100%;
      border: 1px solid rgba(37,99,235,.16);
      background: rgba(255,255,255,.82);
      color: rgba(15,23,42,.92);
      padding: 10px 12px;
      border-radius: 12px;
      outline: none;
      box-shadow: 0 10px 25px rgba(2,6,23,.06);
      transition: box-shadow .12s ease, border-color .12s ease, transform .12s ease;
    }
    .hp-input:focus{
      border-color: rgba(6,182,212,.55);
      box-shadow: 0 0 0 4px var(--ring), 0 12px 28px rgba(2,6,23,.10);
      transform: translateY(-1px);
    }

    .hp-btn{
      border: 1px solid rgba(37,99,235,.18);
      background: rgba(255,255,255,.78);
      color: rgba(15,23,42,.92);
      padding: 10px 12px;
      border-radius: 12px;
      font-weight: 950;
      cursor: pointer;
      box-shadow: 0 10px 25px rgba(2,6,23,.08);
      transition: transform .12s ease, box-shadow .12s ease, opacity .12s ease;
      white-space: nowrap;
    }
    .hp-btn:hover{ transform: translateY(-1px); box-shadow: 0 12px 30px rgba(2,6,23,.10); }
    .hp-btn:disabled{ opacity:.55; cursor:not-allowed; transform:none; box-shadow:none; }
    .hp-btn-accent{
      border-color: rgba(6,182,212,.45);
      background: linear-gradient(90deg, rgba(37,99,235,.14), rgba(6,182,212,.16));
    }

    .dash-surface{
      background: linear-gradient(180deg, rgba(255,255,255,.78), rgba(255,255,255,.55));
      border: 1px dashed rgba(37,99,235,.25);
      border-radius: 18px;
      padding: 12px;
    }

    /* ===== Catalog grid (Catálogo) ===== */
    .catalog-grid{
      margin-top: 12px;
      display: grid;
      gap: 12px;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      align-items: stretch;
    }

    .catalog-card{
      background: linear-gradient(180deg, rgba(255,255,255,.9), rgba(255,255,255,.62));
      border: 1px solid rgba(37,99,235,.14);
      border-radius: 18px;
      overflow: hidden;
      box-shadow: var(--shadow2);
      position: relative;
      transition: transform .14s ease, box-shadow .14s ease, border-color .14s ease;
      display: grid;
      grid-template-rows: auto 1fr;
      min-height: 100%;
    }
    .catalog-card:hover{
      transform: translateY(-2px);
      box-shadow: 0 18px 46px rgba(2,6,23,.12);
      border-color: rgba(6,182,212,.35);
    }

    /* ===== Image ===== */
    .img-wrap{
      position: relative;
      width: 100%;
      aspect-ratio: 4 / 3;
      background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(6,182,212,.12));
      overflow: hidden;
      display: grid;
      place-items: center;
    }
    .img-wrap::after{
      content:"";
      position:absolute;
      inset:0;
      background: linear-gradient(180deg, rgba(2,6,23,.00), rgba(2,6,23,.18));
      opacity: .85;
      pointer-events:none;
    }
    .img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(1.01);
      transition: transform .25s ease, filter .25s ease;
      display:block;
    }
    .catalog-card:hover .img{
      transform: scale(1.06);
      filter: saturate(1.05) contrast(1.02);
    }
    .img-fallback{
      font-weight: 950;
      color: rgba(15,23,42,.65);
      z-index: 2;
      padding: 10px 12px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.55);
      background: rgba(255,255,255,.55);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
    }

    .pill{
      position:absolute;
      z-index: 3;
      top: 10px;
      left: 10px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 10px;
      border-radius: 999px;
      font-weight: 950;
      border: 1px solid rgba(255,255,255,.45);
      background: rgba(255,255,255,.62);
      box-shadow: 0 10px 25px rgba(2,6,23,.10);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      color: rgba(15,23,42,.92);
      max-width: calc(100% - 20px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .pill.right{ left:auto; right:10px; }

    .card-body{
      padding: 12px;
      display: grid;
      gap: 8px;
      align-content: start;
    }
    .name{
      font-weight: 980;
      color: rgba(15,23,42,.92);
      font-size: 15px;
      line-height: 1.25;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 38px;
    }
    .desc{
      color: rgba(15,23,42,.70);
      font-size: 13px;
      line-height: 1.35;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 34px;
    }
    .actions{
      display:flex;
      gap: 8px;
      align-items:center;
      flex-wrap: wrap;
      margin-top: 2px;
    }
    .qty{ width: 130px; max-width: 100%; }

    /* ===== MIS PRODUCTOS ===== */
    .mis-grid{
      margin-top: 12px;
      display: grid;
      gap: 14px;
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
      align-items: stretch;
    }
    .mis-card{
      background: linear-gradient(180deg, rgba(255,255,255,.92), rgba(255,255,255,.62));
      border: 1px solid rgba(37,99,235,.14);
      border-radius: 20px;
      overflow: hidden;
      box-shadow: var(--shadow2);
      display: grid;
      grid-template-rows: auto 1fr;
      transition: transform .14s ease, box-shadow .14s ease, border-color .14s ease;
    }
    .mis-card:hover{
      transform: translateY(-2px);
      box-shadow: 0 18px 46px rgba(2,6,23,.12);
      border-color: rgba(6,182,212,.35);
    }
    .mis-media{ position: relative; }
    .mis-body{
      padding: 14px;
      display: grid;
      gap: 10px;
      align-content: start;
    }
    .mis-title{
      font-weight: 1000;
      font-size: 16px;
      line-height: 1.2;
      color: rgba(15,23,42,.95);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .mis-desc{
      color: rgba(15,23,42,.70);
      font-size: 13px;
      line-height: 1.35;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 34px;
    }
    .mis-chip{
      position:absolute;
      top: 10px;
      z-index: 3;
      display: inline-flex;
      align-items:center;
      gap: 8px;
      padding: 8px 10px;
      border-radius: 999px;
      font-weight: 950;
      border: 1px solid rgba(255,255,255,.45);
      background: rgba(255,255,255,.72);
      box-shadow: 0 10px 25px rgba(2,6,23,.10);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      color: rgba(15,23,42,.92);
      max-width: calc(100% - 20px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .mis-chip.left{ left:10px; }
    .mis-chip.right{ right:10px; }
    .mis-chip.low{ border-color: rgba(239,68,68,.35); }
    .qty-low{ color: #ef4444; font-weight: 1000; }

    /* ===== Tables / KPIs ===== */
    .table{
      width: 100%;
      border-collapse: collapse;
      overflow: hidden;
      border-radius: 14px;
      border: 1px solid rgba(37,99,235,.14);
      background: rgba(255,255,255,.72);
      box-shadow: 0 10px 25px rgba(2,6,23,.06);
    }
    .table th, .table td{
      padding: 10px 10px;
      border-bottom: 1px solid rgba(37,99,235,.10);
      text-align: left;
      font-size: 14px;
      color: rgba(15,23,42,.9);
      vertical-align: top;
    }
    .table th{
      font-weight: 950;
      background: linear-gradient(90deg, rgba(37,99,235,.10), rgba(6,182,212,.10));
    }
    .kpi{
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
      margin-top: 10px;
    }
    .kpi-card{
      border-radius: 18px;
      border: 1px solid rgba(37,99,235,.14);
      background: rgba(255,255,255,.70);
      box-shadow: 0 10px 25px rgba(2,6,23,.06);
      padding: 12px;
    }
    .kpi-title{ font-weight: 980; color: rgba(15,23,42,.92); }
    .kpi-value{ margin-top: 6px; font-weight: 980; font-size: 18px; color: rgba(15,23,42,.92); }
    .kpi-help{ margin-top: 6px; color: rgba(15,23,42,.65); font-size: 13px; }

    .mini-thumb{
      width: 56px;
      height: 42px;
      border-radius: 12px;
      border: 1px solid rgba(37,99,235,.14);
      overflow: hidden;
      background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(6,182,212,.12));
    }
    .mini-thumb img{ width:100%; height:100%; object-fit:cover; display:block; }

    @media (max-width: 420px){
      .qty{ width: 100%; }
    }
  `}</style>
);

function ProductImage({ src, alt }) {
  const [ok, setOk] = useState(true);
  const url = src || "";
  return (
    <div className="img-wrap">
      {url && ok ? (
        <img
          className="img"
          src={url}
          alt={alt || "Producto"}
          loading="lazy"
          onError={() => setOk(false)}
        />
      ) : (
        <div className="img-fallback">🛍️ Sin imagen</div>
      )}
    </div>
  );
}

export default function ProductsPanel({ userData, setUserData, userDocId }) {
  const [tab, setTab] = useState("mis"); // mis | catalogo | ventas | logros

  const [misProductos, setMisProductos] = useState([]);
  const [userProductosAll, setUserProductosAll] = useState([]);

  const [catalogo, setCatalogo] = useState([]);
  const [catSearch, setCatSearch] = useState("");
  const [catLoading, setCatLoading] = useState(false);

  const [userQtyEditMap, setUserQtyEditMap] = useState({});

  const [ventas, setVentas] = useState([]);
  const [ventasLoading, setVentasLoading] = useState(true);
  const [selectedDayKey, setSelectedDayKey] = useState(dayKeyFromDate(new Date()));

  const puntos = normalizeNumber(userData?.Cpuntos);
  const canEditUserQty = puntos >= PUNTOS_MIN_PERMISO;

  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => (mountedRef.current = false);
  }, []);

  // ===== ProductosUsuario =====
  useEffect(() => {
    if (!userDocId) return;

    const qMis = query(collection(db, "ProductosUsuario"), where("userId", "==", userDocId));
    const unsub = onSnapshot(
      qMis,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        if (mountedRef.current) setUserProductosAll(rows);

        const onlyAvail = rows
          .filter((r) => normalizeNumber(r.cantidadDisponible) > 0) // ✅ ocultar 0
          .sort((a, b) => {
            const at = a.updatedAt?.toMillis?.() ?? a.createdAt?.toMillis?.() ?? 0;
            const bt = b.updatedAt?.toMillis?.() ?? b.createdAt?.toMillis?.() ?? 0;
            return bt - at;
          });

        if (mountedRef.current) setMisProductos(onlyAvail);
      },
      (err) => {
        console.error("ProductosUsuario snapshot:", err);
        if (mountedRef.current) {
          setUserProductosAll([]);
          setMisProductos([]);
        }
      }
    );

    return () => unsub();
  }, [userDocId]);

  // ===== Catálogo: CaProducto (FIX: _docId real) =====
  const fetchCatalogo = async () => {
    setCatLoading(true);
    try {
      const snap = await getDocs(collection(db, "CaProducto"));
      const data = snap.docs.map((d) => ({
        ...d.data(),
        _docId: d.id, // ✅ SIEMPRE el docId real
      }));
      if (mountedRef.current) setCatalogo(data);
    } catch (err) {
      console.error("Error cargando CaProducto:", err);
      if (mountedRef.current) setCatalogo([]);
    } finally {
      if (mountedRef.current) setCatLoading(false);
    }
  };

  useEffect(() => {
    fetchCatalogo();
    // eslint-disable-next-line
  }, []);

  // ===== Ventas =====
  useEffect(() => {
    if (!userDocId) return;
    setVentasLoading(true);

    const qVentas = query(
      collection(db, "VentasProductos"),
      where("userId", "==", userDocId),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      qVentas,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        if (mountedRef.current) setVentas(rows);
        if (mountedRef.current) setVentasLoading(false);
        if (rows.length > 0 && rows[0].dayKey) setSelectedDayKey(rows[0].dayKey);
      },
      (err) => {
        console.error("VentasProductos snapshot:", err);
        if (mountedRef.current) setVentas([]);
        if (mountedRef.current) setVentasLoading(false);
      }
    );

    return () => unsub();
  }, [userDocId]);

  // ===== Mapa: idCatalogo -> doc ProductosUsuario =====
  const userByCatalogId = useMemo(() => {
    const m = new Map();
    for (const p of userProductosAll) {
      if (p?.idCatalogo) m.set(p.idCatalogo, p);
    }
    return m;
  }, [userProductosAll]);

  // ===== Catálogo filtrado =====
  const catalogoFiltrado = useMemo(() => {
    const s = catSearch.trim().toLowerCase();
    let items = [...catalogo];

    if (s) {
      items = items.filter(
        (p) =>
          (p.name || "").toLowerCase().includes(s) ||
          (p.description || "").toLowerCase().includes(s) ||
          (p._docId || "").toLowerCase().includes(s)
      );
    }

    items.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    return items;
  }, [catalogo, catSearch]);

  // ===== Ventas por día =====
  const ventasPorDia = useMemo(() => {
    const map = new Map();
    for (const v of ventas) {
      const key = v.dayKey || "Sin fecha";
      const prev = map.get(key) || {
        dayKey: key,
        totalBruto: 0,
        totalComision: 0,
        totalNeto: 0,
        totalQty: 0,
        items: [],
      };

      prev.totalBruto += normalizeNumber(v.bruto);
      prev.totalComision += normalizeNumber(v.comisionSistema);
      prev.totalNeto += normalizeNumber(v.netoUsuario);
      prev.totalQty += normalizeNumber(v.qty);
      prev.items.push(v);

      map.set(key, prev);
    }

    const arr = Array.from(map.values());
    arr.sort((a, b) => (a.dayKey < b.dayKey ? 1 : -1));
    return arr;
  }, [ventas]);

  const kpis = useMemo(() => {
    let bruto = 0,
      com = 0,
      neto = 0,
      qty = 0;
    for (const v of ventas) {
      bruto += normalizeNumber(v.bruto);
      com += normalizeNumber(v.comisionSistema);
      neto += normalizeNumber(v.netoUsuario);
      qty += normalizeNumber(v.qty);
    }
    return { bruto, com, neto, qty };
  }, [ventas]);

  const selectedDay = useMemo(
    () => ventasPorDia.find((d) => d.dayKey === selectedDayKey) || null,
    [ventasPorDia, selectedDayKey]
  );

  // ========= Guardar cantidad del usuario =========
  const guardarCantidadUsuario = async (catDocIdReal) => {
    try {
      if (!catDocIdReal || typeof catDocIdReal !== "string") {
        return alert("ID de catálogo inválido. No se puede guardar.");
      }
      if (!userDocId || typeof userDocId !== "string") {
        return alert("No se detectó el usuario (userDocId inválido).");
      }

      const raw = userQtyEditMap[catDocIdReal];
      const cantidad = normalizeNumber(raw);
      const cantidadInt = Number.isFinite(cantidad) ? Math.trunc(cantidad) : 0;

      if (cantidadInt < 0) return alert("Ingresa una cantidad válida (entera y >= 0).");

      const userSocioRef = doc(db, "userSocio", userDocId);
      const catRef = doc(db, "CaProducto", catDocIdReal);

      const puId = `${userDocId}__${catDocIdReal}`;
      const puRef = doc(db, "ProductosUsuario", puId);

      await runTransaction(db, async (trx) => {
        const userSnap = await trx.get(userSocioRef);
        if (!userSnap.exists()) throw new Error("No existe el usuario en userSocio.");

        const puntosActual = normalizeNumber(userSnap.data()?.Cpuntos);
        if (puntosActual < PUNTOS_MIN_PERMISO) {
          throw new Error(
            `No puedes editar cantidades. Tienes ${puntosActual} y necesitas mínimo ${PUNTOS_MIN_PERMISO}.`
          );
        }

        const catSnap = await trx.get(catRef);
        if (!catSnap.exists()) throw new Error("Producto no existe en catálogo.");
        const catData = catSnap.data();

        const precio = normalizeNumber(catData.precio);
        const imageUrl = getImage(catData);
        const images = Array.isArray(catData.images) ? catData.images : [];

        trx.set(
          puRef,
          {
            userId: userDocId,
            codigoApp: userData?.codigoApp ?? null,
            idCatalogo: catDocIdReal,

            name: catData.name || "Producto",
            description: catData.description || "",
            precio,
            imageUrl,
            images,

            cantidadDisponible: cantidadInt,
            updatedAt: serverTimestamp(),
            createdAt: serverTimestamp(),
          },
          { merge: true }
        );
      });

      alert("✅ Cantidad guardada");
    } catch (err) {
      console.error("guardarCantidadUsuario", err);
      alert(`❌ No se pudo guardar: ${err?.message || "Error"}`);
    }
  };

  return (
    <div className="hp-hero">
      <GlobalProductsHomeCSS />

      <div className="hp-inner">
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <h3 className="hp-title" style={{ margin: 0 }}>
            Productos
          </h3>

          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <div className="hp-badge">⭐ Puntos: {puntos}</div>

            <div className="hp-tabs" role="tablist" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button className={`tab ${tab === "mis" ? "active" : ""}`} onClick={() => setTab("mis")}>
                Mis productos
              </button>
              <button className={`tab ${tab === "catalogo" ? "active" : ""}`} onClick={() => setTab("catalogo")}>
                Catálogo
              </button>
              <button className={`tab ${tab === "ventas" ? "active" : ""}`} onClick={() => setTab("ventas")}>
                Ventas
              </button>
              <button className={`tab ${tab === "logros" ? "active" : ""}`} onClick={() => setTab("logros")}>
                Logros
              </button>
            </div>
          </div>
        </div>

        {/* ====================== MIS PRODUCTOS (SOLO VISTA + ROJO <=5 + OCULTA 0) ====================== */}
        {tab === "mis" && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <div className="hp-badge">📦 Mis productos</div>
              <div className="hp-help" style={{ paddingTop: 0 }}>
                Inventario disponible en tu cuenta.
              </div>
            </div>

            {misProductos.length === 0 ? (
              <div className="hp-help" style={{ fontStyle: "italic", color: COLORS_SAFE?.textDim || "rgba(15,23,42,.65)" }}>
                No tienes productos disponibles ahora mismo.
              </div>
            ) : (
              <div className="mis-grid">
                {misProductos.map((p) => {
                  const disp = normalizeNumber(p.cantidadDisponible);
                  const precio = normalizeNumber(p.precio);
                  const img = getImage(p);
                  const isLow = disp <= 5;

                  return (
                    <div key={p.id} className="mis-card">
                      <div className="mis-media">
                        <ProductImage src={img} alt={p.name} />

                        <div className={`mis-chip left ${isLow ? "low" : ""}`}>
                          📦 Disponible: <span className={isLow ? "qty-low" : ""}>{disp}</span>
                        </div>

                        <div className="mis-chip right">💰 {currency(precio)}</div>
                      </div>

                      <div className="mis-body">
                        <div className="mis-title">{p.name || "Producto"}</div>
                        <div className="mis-desc">{p.description || "—"}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ====================== LOGROS ====================== */}
        {tab === "logros" && <Logros userData={userData} />}

        {/* ====================== CATALOGO ====================== */}
        {tab === "catalogo" && (
          <div className="dash-surface">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
              <div className="hp-badge">🛒 Catálogo</div>

              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <input
                  className="hp-input"
                  style={{ maxWidth: 320 }}
                  placeholder="Buscar (nombre, desc, ID)"
                  value={catSearch}
                  onChange={(e) => setCatSearch(e.target.value)}
                />
                <button className="hp-btn" onClick={fetchCatalogo} disabled={catLoading}>
                  {catLoading ? "Actualizando…" : "Actualizar"}
                </button>
              </div>
            </div>

            {/* 🔕 sin textos extra: solo una línea discreta */}
            <div className="hp-help" style={{ paddingTop: 8 }}>
              {canEditUserQty
                ? `✅ Puedes editar (tienes ${puntos} puntos).`
                : `🔒 Solo lectura (tienes ${puntos}, mínimo ${PUNTOS_MIN_PERMISO}).`}
            </div>

            {catLoading ? (
              <div className="hp-help" style={{ paddingTop: 10 }}>
                Cargando catálogo…
              </div>
            ) : catalogoFiltrado.length === 0 ? (
              <div className="hp-help" style={{ paddingTop: 10 }}>
                No hay productos para mostrar.
              </div>
            ) : (
              <div className="catalog-grid">
                {catalogoFiltrado.map((c, idx) => {
                  const catId = c?._docId;

                  if (!catId) {
                    return (
                      <div key={`invalid-${idx}`} className="catalog-card">
                        <div className="card-body">
                          <div className="name">Producto inválido</div>
                          <div className="hp-help">Falta ID del documento en catálogo.</div>
                        </div>
                      </div>
                    );
                  }

                  const precio = normalizeNumber(c.precio);
                  const img = getImage(c);

                  const userDoc = userByCatalogId.get(catId);
                  const currentUserQty = normalizeNumber(userDoc?.cantidadDisponible);

                  const editValue =
                    userQtyEditMap[catId] !== undefined ? userQtyEditMap[catId] : String(currentUserQty);

                  return (
                    <div key={catId} className="catalog-card">
                      <div style={{ position: "relative" }}>
                        <ProductImage src={img} alt={c.name} />
                        <div className="pill">📦 Mi disponible: {currentUserQty}</div>
                        <div className="pill right">💰 {currency(precio)}</div>
                      </div>

                      <div className="card-body">
                        <div className="name">{c.name || "Producto"}</div>
                        <div className="desc">{c.description ? c.description : "—"}</div>

                        <div className="actions">
                          <input
                            className="hp-input qty"
                            type="number"
                            min="0"
                            placeholder="Mi cantidad"
                            value={editValue}
                            onChange={(e) => setUserQtyEditMap((m) => ({ ...m, [catId]: e.target.value }))}
                            disabled={!canEditUserQty}
                          />
                          <button
                            className="hp-btn hp-btn-accent"
                            disabled={!canEditUserQty || !catId}
                            onClick={() => guardarCantidadUsuario(catId)}
                            title={!canEditUserQty ? `Necesitas ${PUNTOS_MIN_PERMISO} puntos` : "Guardar mi cantidad"}
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ====================== VENTAS ====================== */}
        {tab === "ventas" && (
          <div className="dash-surface">
            <div className="hp-badge">📊 Ventas</div>

            <div className="kpi">
              <div className="kpi-card">
                <div className="kpi-title">Total vendido (Bruto)</div>
                <div className="kpi-value">{currency(kpis.bruto)}</div>
                <div className="kpi-help">Suma total antes de comisión.</div>
              </div>
              <div className="kpi-card">
                <div className="kpi-title">Comisión sistema (5%)</div>
                <div className="kpi-value">{currency(kpis.com)}</div>
                <div className="kpi-help">5% por cada venta registrada.</div>
              </div>
              <div className="kpi-card">
                <div className="kpi-title">Neto usuario</div>
                <div className="kpi-value">{currency(kpis.neto)}</div>
                <div className="kpi-help">Bruto - comisión.</div>
              </div>
              <div className="kpi-card">
                <div className="kpi-title">Unidades vendidas</div>
                <div className="kpi-value">{kpis.qty}</div>
                <div className="kpi-help">Cantidad total vendida.</div>
              </div>
            </div>

            {ventasLoading ? (
              <div className="hp-help" style={{ marginTop: 10 }}>
                Cargando ventas…
              </div>
            ) : ventasPorDia.length === 0 ? (
              <div className="hp-help" style={{ marginTop: 10 }}>
                Aún no hay ventas registradas.
              </div>
            ) : (
              <div style={{ marginTop: 12 }}>
                <div style={{ overflowX: "auto" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Día</th>
                        <th>Ventas</th>
                        <th>Unidades</th>
                        <th>Bruto</th>
                        <th>Comisión</th>
                        <th>Neto</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ventasPorDia.map((d) => {
                        const active = d.dayKey === selectedDayKey;
                        return (
                          <tr key={d.dayKey} style={{ background: active ? "rgba(6,182,212,.08)" : "transparent" }}>
                            <td style={{ fontWeight: 950 }}>{d.dayKey}</td>
                            <td>{d.items.length}</td>
                            <td>{d.totalQty}</td>
                            <td>{currency(d.totalBruto)}</td>
                            <td>{currency(d.totalComision)}</td>
                            <td>{currency(d.totalNeto)}</td>
                            <td>
                              <button className="hp-btn" onClick={() => setSelectedDayKey(d.dayKey)}>
                                Ver detalle
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {selectedDay?.items?.length > 0 && (
                  <div style={{ marginTop: 12 }}>
                    <div className="hp-badge">🧾 Detalle del día: {selectedDay.dayKey}</div>

                    <div style={{ marginTop: 10, overflowX: "auto" }}>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Producto</th>
                            <th>Imagen</th>
                            <th>Cant.</th>
                            <th>Precio</th>
                            <th>Bruto</th>
                            <th>Comisión</th>
                            <th>Neto</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedDay.items.slice(0, 200).map((v) => (
                            <tr key={v.id}>
                              <td style={{ fontWeight: 900 }}>{v.name || "Producto"}</td>
                              <td>
                                <div className="mini-thumb">
                                  {v.imageUrl ? (
                                    <img src={v.imageUrl} alt={v.name || "Producto"} loading="lazy" />
                                  ) : null}
                                </div>
                              </td>
                              <td>{normalizeNumber(v.qty)}</td>
                              <td>{currency(v.precioUnit)}</td>
                              <td>{currency(v.bruto)}</td>
                              <td>{currency(v.comisionSistema)}</td>
                              <td>{currency(v.netoUsuario)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="hp-help">Mostrando hasta 200 registros del día seleccionado.</div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
